import { Appointment, TAptField } from "@elixir/types";
import { useEffect, useState } from "react";
import { TextFieldUi } from "ui";
import usePushAptFieldToApt from "../../../../apis/tryst/use-push-apt-field-to-apt";

const TextFieldAction = ({
  apt,
  fieldItem,
  isDisabled = false,
}: {
  apt: Appointment;
  fieldItem: TAptField;
  isDisabled?: boolean;
}) => {
  const [fieldValue, setFieldValue] = useState<string>("");
  useEffect(() => {
    const aptField = apt.apt_fields?.filter(
      (aptField) => aptField.field_id === fieldItem.field_id
    );
    const { values } = aptField?.[0] || {};
    const fieldValue = values?.[0] || "";
    setFieldValue(fieldValue);
  }, [apt, fieldItem]);

  const { mutateAsync: pushAptFieldToApt } = usePushAptFieldToApt();

  const handleSubmit = () => {
    pushAptFieldToApt({
      appointment: apt,
      fieldId: fieldItem.field_id,
      fieldValues: [fieldValue],
    });
  };
  return (
    <TextFieldUi
      fieldName={fieldItem.title.replace(/_/g, " ")}
      fieldValue={fieldValue}
      onFieldValueChange={(value) => setFieldValue(value)}
      onSubmit={handleSubmit}
      isDisabled={isDisabled}
    />
  );
};

export default TextFieldAction;
